import { Share2 } from 'lucide-react';
import { WatchlistSubNav } from '@/components/watchlist/SubNav';
import { wl } from '@/components/watchlist/theme';

// Honest "coming soon" — not a mocked feature. Confirmed by reading the live
// code: the Entity Ontology fuses matching observations into one entity
// rather than exposing a cluster of linked accounts, and the existing
// social-identity-correlation service links one person's own accounts by
// handle/name similarity, not impersonator rings by shared payment-ID/
// wallet/phone/domain. Account clustering + a CIB score need a genuinely
// new data model and matching service — flagged, not quietly faked here.
export default function OperatorsPage() {
  return (
    <div style={{ background: wl.bg, minHeight: '100%' }} className="flex flex-col -m-6 p-6">
      <WatchlistSubNav />
      <div className="flex items-center justify-between mb-5">
        <div>
          <h1 style={{ color: wl.text, fontWeight: 800, fontSize: 16 }}>Operators</h1>
          <p style={{ color: wl.textMuted, fontSize: 12, marginTop: 2 }}>Coordinated account networks behind your impersonation findings</p>
        </div>
      </div>

      <div
        className="flex flex-col items-center justify-center text-center gap-4"
        style={{ background: wl.surface, border: `1px dashed ${wl.border}`, borderRadius: 10, padding: '60px 32px' }}
      >
        <div style={{ width: 52, height: 52, borderRadius: 12, background: wl.greenWash, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Share2 size={24} style={{ color: wl.green }} />
        </div>
        <div>
          <p style={{ color: wl.text, fontWeight: 700, fontSize: 14 }}>Operator clustering — coming soon</p>
          <p style={{ color: wl.textMuted, fontSize: 12.5, marginTop: 6, maxWidth: 480, lineHeight: 1.6 }}>
            Groups fake accounts that share a payment ID, phone number, wallet address,
            or domain into one operator, with a coordination score and a timeline of
            when new accounts appear — usually right after an earlier batch is taken down.
          </p>
          <p style={{ color: wl.textFaint, fontSize: 11, marginTop: 10 }}>
            Needs a new matching service — not wired into any detection yet.
          </p>
        </div>
      </div>
    </div>
  );
}
